import React, { Component } from "react";
import { connect } from "react-redux";
import ReactDOM from "react-dom";
import KpsListItem from "../../core-elements/KpsListItem";
import CreateIcon from "@material-ui/icons/Create";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import StarIcon from "@material-ui/icons/Star";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import AssignmentLateIcon from "@material-ui/icons/AssignmentLate";
import AddAlertIcon from "@material-ui/icons/AddAlert";
import FlagIcon from "@material-ui/icons/Flag";
import Typography from "@material-ui/core/Typography";
import ListItemText from "@material-ui/core/ListItemText";
import { withRouter } from "react-router";
import { Trans, withTranslation } from "react-i18next";
import { withStyles, withTheme } from "@material-ui/core/styles";
import DocumentCategories from "../document/DocumentCategories";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { Badge, Tooltip } from "@material-ui/core";
import DisplayUser from "../user/DisplayUser";
import Link from "@material-ui/core/Link";
import moment from "moment";
import DisplayLocation from "../taxonomy/discussions/DisplayLocation";
import IconButton from "@material-ui/core/IconButton";
import TabIcon from "@material-ui/icons/Tab";
import ChromeReaderModeIcon from "@material-ui/icons/ChromeReaderMode";
import axios from "../../AxiosClient";
import PubSub from "pubsub-js";
import { PORTLET_LAYOUT_ADD } from "../../utils/Topics";
import PropertyNames from "../../PropertyNames";
import { Role, currentUserHasRole } from "../../utils/RoleUtils";
import DisplayDocumentType from "../DisplayDocumentType";
const styles = (theme) => ({
  iconSpan: {
    marginRight: theme.spacing(1),
    "& > svg": {
      verticalAlign: "middle",
    },
  },
  secondarySpan: {
    verticalAlign: "middle",
    display: "flex",
    // paddingLeft: theme.spacing(1),
  },
  buttontitle: {
    textAlign: "left",
  },
  noWrap: {
    whiteSpace: "nowrap",
  },
});
export class DocumentItem extends Component {
  state = {
    extendedString: "",
    documentViewerOpen: false,
    viewingDocument: null,
    secondaryString: "",
  };

  componentDidMount() {
    this.extendedInfo(this.props.extendedSettings);
    this.secondaryInfo(this.props.listSettings);
    this.defaultFullscreenInfo(this.props.fullscreenSettings);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.extendedSettings !== this.props.extendedSettings) {
      this.extendedInfo(this.props.extendedSettings);
    }
    if (prevProps.listSettings !== this.props.listSettings) {
      this.secondaryInfo(this.props.listSettings);
    }
    if (this.props.fullscreen != prevProps.fullscreen) {
      if (this.props.fullscreen) {
        this.secondaryInfo(this.props.fullscreenSettings);
      } else {
        this.secondaryInfo(this.props.listSettings);
      }
    }
    if (
      this.props.fullscreenSettings != prevProps.fullscreenSettings &&
      this.props.fullscreen
    ) {
      this.secondaryInfo(this.props.fullscreenSettings);
    }
  }

  render() {
    const { classes } = this.props;
    let hasButton =
      this.props.properties[PropertyNames.DISPLAY_NEW_DOCUMENT_PORTLET_ICON] ===
        "true" ||
      this.props.properties[PropertyNames.DISPLAY_NEW_TAB_ICON] === "true";
    const child = (
      <KpsListItem
        preText={this.props.preText}
        isPortlet={this.props.isPortlet}
        onItemClick={this.onItemClick}
        extendedString={this.state.extendedString}
        provided={this.props.provided}
        menuDialog={this.props.menuDialog}
        fullscreen={this.props.fullscreen}
        secondaryAction={
          !this.props.noIcons &&
          hasButton && (
            <div className={classes.noWrap}>
              {this.props.properties[PropertyNames.DISPLAY_NEW_TAB_ICON] ===
                "true" && (
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    let win2 = window.open(
                      `/full/document/${this.props.data.documentID}`,
                      "_blank"
                    );
                    win2.title = this.props.data.userTitle;
                    win2.onload = function() {
                      win2.document.title = win2.title;
                    };
                    win2.blur();
                    window.focus();
                  }}
                >
                  <Tooltip title={"Open Document in new tab"}>
                    <TabIcon />
                  </Tooltip>
                </IconButton>
              )}
              {this.props.properties[
                PropertyNames.DISPLAY_NEW_DOCUMENT_PORTLET_ICON
              ] === "true" &&                         
              (this.props.portalLayout.layoutType === "user" ||
                (this.props.portalLayout.layoutType === "team" &&
                  currentUserHasRole(Role.TEAM_LEADER) &&
                  this.props.teamLayoutEditMode === true)) && (
                <IconButton onClick={this.addToLayout}>
                  <Tooltip title={this.props.t("create_document_portlet")}>
                    <ChromeReaderModeIcon />
                  </Tooltip>
                </IconButton>
              )}
            </div>
          )
        }
        fullscreenSettings={
          this.props.fullscreenSettings &&
          this.props.fullscreenSettings !== null
            ? JSON.parse(this.props.fullscreenSettings).map((setting, idx) => {
                return <>{this.getSettingInfo(setting)}</>;
              })
            : this.state.defaultFullscreen
        }
      >
        {this.props.preText}
        {this.props.fullscreen ? (
          <Link
            component="button"
            color="inherit"
            underline="none"
            classes={{ button: classes.buttontitle }}
            // onClick={this.onItemClick}
          >
            {this.props.data.userTitle}
          </Link>
        ) : (
          <ListItemText
            primary={this.props.data.userTitle}
            secondary={this.state.secondaryString}
            style={{ overflowWrap: "anywhere" }}
          />
        )}
      </KpsListItem>
    );
    if (this.props.snapshot && this.props.snapshot.isDragging) {
      return ReactDOM.createPortal(child, document.body);
    }
    return child;
  }

  addToLayout = (e) => {
    e.stopPropagation();
    let portlet = {};
    portlet.children = [];
    portlet.elementType = "CardDocument";
    portlet.icon = "chrome_reader_mode";
    portlet.isDefault = 1;
    portlet.isHidden = 0;
    portlet.isUser = 0;
    portlet.menuPortletId = 1142;
    portlet.objectClass = "";
    portlet.order = 0;
    portlet.isportlet = true;
    portlet.fullscreen = false;
    portlet.id = null;
    portlet.settingsExtended = null;
    portlet.settingsFullscreen = null;
    portlet.settingsList = null;
    portlet.instance = new Date().getTime();
    portlet.parameters = JSON.stringify({
      documentId: this.props.data.documentID,
    });
    portlet.title = this.props.data.userTitle;
    axios
      .post(`/portalLayout/${this.props.portalLayout.id}/portlet/`, {
        ...portlet,
      })
      .then((res) => {
        PubSub.publish(PORTLET_LAYOUT_ADD, {
          layoutId: this.props.portalLayout.id,
          portletId: res.data.id,
        });
      });
  };

  onItemClick = () => {
    if (this.props.onItemClick) {
      this.props.onItemClick(this.props.data);
    } else {
      this.props.history.push(`/full/document/${this.props.data.documentID}`);
    }
  };

  onUpdatedClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (this.props.onItemClick) {
      this.props.onItemClick(this.props.data);
    } else {
      this.props.history.push(`/full/document/${this.props.data.documentID}`, {
        showDiff: true,
      });
    }
  };
  extendedInfo(settings) {
    if (!settings || settings.length === 0) {
      settings = [];
      for (let i = 0; i < this.props.documentOptions.length; i++) {
        settings.push({ label: this.props.documentOptions[i], order: i });
      }
    } else {
      settings = JSON.parse(settings);
    }
    var extendedString = (
      <>
        {settings.map((setting, idx) => {
          return (
            <>
              {(setting.label !== "settings_document_rework_count" ||
                this.props.currentUser.userPermits.roles.beExpert) && (
                <TableRow>
                  <TableCell>{this.props.t(setting.label)}</TableCell>
                  {this.getSettingInfo(setting)}
                </TableRow>
              )}
            </>
          );
        })}
      </>
    );
    this.setState({ extendedString: extendedString });
  }
  defaultFullscreenInfo(settings) {
    if (!settings || settings.length === 0) {
      settings = [];
      for (let i = 0; i < this.props.documentOptions.length; i++) {
        settings.push({ label: this.props.documentOptions[i], order: i });
      }
    } else {
      try {
        let jsonsettings = JSON.parse(settings);
        settings = jsonsettings;
      } catch (x) {
        settings = [{ label: settings, order: 0 }];
      }
    }
    var fullScreenString = (
      <>
        {settings.map((setting, idx) => {
          return <>{this.getSettingInfo(setting)}</>;
        })}
      </>
    );
    this.setState({ defaultFullscreen: fullScreenString });
  }
  getSettingInfo = (setting) => {
    return (
      <>
        {setting.label === "document_type" && (
          <TableCell>
            <DisplayDocumentType
              documentTypeId={this.props.data.documentTypeId}
            />
          </TableCell>
        )}
        {(setting.label === "global_category_plural" || setting.label === "settings_document_categories") && (
          <TableCell>
            <DocumentCategories
              defaultValue={this.props.data.documentCategories}
              chipsOnly
            />
          </TableCell>
        )}
        {setting.label === "global_topic" && (
          <TableCell>
            <DisplayLocation
              type="TOPIC"
              itemId={this.props.data.communityId}
              topicId={this.props.data.communityId}
              title={this.props.data.topicName}
            />
          </TableCell>
        )}
        {setting.label === "settings_document_revalidation_date" && (
          <TableCell>
            {!!this.props.data.revalidationDate
              ? moment(this.props.data.revalidationDate).format("LL")
              : "n/a"}
          </TableCell>
        )}
        {setting.label === "settings_document_created_date" && (
          <TableCell>
            {!!this.props.data.dateCreated
              ? moment(this.props.data.dateCreated).format("LLL")
              : "n/a"}
          </TableCell>
        )}
        {setting.label === "settings_document_last_date_modified" && (
          <TableCell>
            {!!this.props.data.dateModified
              ? moment(this.props.data.dateModified).format("LLL")
              : "n/a"}
          </TableCell>
        )}
        {setting.label === "settings_document_number_of_liked" && (
          <TableCell>
            {this.props.data.likedCount}
            {this.props.data.likedCount > 0 &&
              this.props.data.likedRanking > 0 && (
                <span style={{ marginLeft: "10px" }}>
                  <Tooltip
                    title={
                      <Typography>
                        {this.props.t("global_ranked") +
                          " " +
                          this.props.data.likedRanking +
                          " " +
                          this.props.t("global_most_liked")}
                      </Typography>
                    }
                  >
                    <Badge>
                      <span
                        style={{ fontSize: "1.4em", marginRight: "3px" }}
                        className="mdi mdi-trophy-outline"
                      />
                      {this.props.data.likedRanking}
                    </Badge>
                  </Tooltip>
                </span>
              )}
          </TableCell>
        )}
        {setting.label === "settings_document_number_of_times_favourited" && (
          <TableCell>
            {this.props.data.favouritedCount}
            {this.props.data.favouritedCount > 0 &&
              this.props.data.favouriteRanking > 0 && (
                <span style={{ marginLeft: "10px" }}>
                  <Tooltip
                    title={
                      <Typography>
                        {this.props.t("global_ranked") +
                          " " +
                          this.props.data.favouriteRanking +
                          " " +
                          this.props.t("global_most_favourited")}
                      </Typography>
                    }
                  >
                    <Badge>
                      <span
                        style={{ fontSize: "1.4em", marginRight: "3px" }}
                        className="mdi mdi-trophy-outline"
                      />
                      {this.props.data.favouriteRanking}
                    </Badge>
                  </Tooltip>
                </span>
              )}
          </TableCell>
        )}
        {setting.label === "settings_document_number_of_times_viewed" && (
          <TableCell>
            {this.props.data.viewedCount}
            {this.props.data.viewedCount > 0 &&
              this.props.data.viewedRanking > 0 && (
                <span style={{ marginLeft: "10px" }}>
                  <Tooltip
                    title={
                      <Typography>
                        {this.props.t("global_ranked") +
                          " " +
                          this.props.data.viewedRanking +
                          " " +
                          this.props.t("global_most_viewed")}
                      </Typography>
                    }
                  >
                    <Badge>
                      <span
                        style={{ fontSize: "1.4em", marginRight: "3px" }}
                        className="mdi mdi-trophy-outline"
                      />
                      {this.props.data.viewedRanking}
                    </Badge>
                  </Tooltip>
                </span>
              )}
          </TableCell>
        )}
        {setting.label === "settings_document_number_of_times_used" && (
          <TableCell>
            {this.props.data.usedCount}
            {this.props.data.usedCount > 0 &&
              this.props.data.usageRanking > 0 && (
                <span style={{ marginLeft: "10px" }}>
                  <Tooltip
                    title={
                      <Typography>
                        {this.props.t("global_ranked") +
                          " " +
                          this.props.data.usageRanking +
                          " " +
                          this.props.t("global_most_used")}
                      </Typography>
                    }
                  >
                    <Badge>
                      <span
                        style={{ fontSize: "1.4em", marginRight: "3px" }}
                        className="mdi mdi-trophy-outline"
                      />
                      {this.props.data.usageRanking}
                    </Badge>
                  </Tooltip>
                </span>
              )}
          </TableCell>
        )}
        {setting.label === "settings_document_date_last_viewed_by_me" && (
          <TableCell>
            {!!this.props.data.myLastViewed
              ? moment(this.props.data.myLastViewed).format("LLL")
              : "n/a"}
          </TableCell>
        )}
        {setting.label === "settings_document_user_who_last_modified" &&
        this.props.data.isKnowledgeItem === true ? (
          <TableCell>
            <DisplayUser
              userId={
                this.props.data.lastModifiedByUser
                  ? this.props.data.lastModifiedByUser.userId
                  : ""
              }
              user={this.props.data.lastModifiedByUser}
            />
          </TableCell>
        ) : (
          setting.label === "settings_document_user_who_last_modified" && (
            <TableCell>{this.props.t("global_not_applicable")}</TableCell>
          )
        )}
        {this.props.currentUser.userPermits.roles.beExpert && (
          <>
            {setting.label === "settings_document_rework_count" &&
            // this.props.data.canMarkForRework &&
            this.props.data.isKnowledgeItem === true ? (
              <TableCell>{this.props.data.reworkCount}</TableCell>
            ) : (
              setting.label === "settings_document_rework_count" && (
                <TableCell>{this.props.t("global_not_applicable")}</TableCell>
              )
            )}
          </>
        )}
        {setting.label === "settings_document_author" &&
        this.props.data.isKnowledgeItem === true ? (
          <TableCell>
            <DisplayUser
              userId={
                this.props.data.author ? this.props.data.author.userId : ""
              }
              user={this.props.data.author}
            />
          </TableCell>
        ) : (
          setting.label === "settings_document_author" && (
            <TableCell>{this.props.t("global_not_applicable")}</TableCell>
          )
        )}
        {setting.label === "settings_document_live_revision_author" &&
        this.props.data.isKnowledgeItem === true ? (
          <TableCell>
            {/* <DisplayUser userId={this.props.data.author} /> */}
            <DisplayUser
              userId={
                this.props.data.liveRevisionAuthor
                  ? this.props.data.liveRevisionAuthor.userId
                  : ""
              }
              user={this.props.data.liveRevisionAuthor}
            />
          </TableCell>
        ) : (
          setting.label === "settings_document_live_revision_author" && (
            <TableCell>{this.props.t("global_not_applicable")}</TableCell>
          )
        )}
      </>
    );
  };

  returnSettingsItem = (setting) => {
    const { classes } = this.props;
    let fontWeight = {
      fontWeight: this.props.fullscreen ? "bold" : "normal",
      paddingRight: this.props.theme.spacing(1),
    };
    return (
      <span className={classes.secondarySpan}>
        {setting === "settings_document_categories" || setting === "global_category_plural" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("global_category_plural")}:
            </div>
            <div>
              <DocumentCategories
                chipsOnly
                defaultValue={this.props.data.documentCategories}
              />
            </div>
          </div>
        )}
        {setting === "document_type" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("document_type")}:
            </div>
            <div>
              <DisplayDocumentType
                documentTypeId={this.props.data.documentTypeId}
              />
            </div>
          </div>
        )}
        {setting === "global_topic" && (
          <DisplayLocation
            type="TOPIC"
            itemId={this.props.data.communityId}
            topicId={this.props.data.communityId}
            title={this.props.data.topicName}
          />
        )}
        {setting === "settings_document_last_date_modified" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_document_last_date_modified")}
            </div>
            <div>{moment(this.props.data.dateModified).format("LLL")}&nbsp;</div>
          </div>
        )}
        {setting === "settings_document_created_date" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_document_created_date")}
            </div>
            <div>{moment(this.props.data.dateCreated).format("LLL")}&nbsp;</div>
          </div>
        )}
        {setting === "settings_document_number_of_liked" && (
          <>
            {this.props.data.likedRanking > 0 && (
              <span style={{ marginRight: "3px" }}>
                <Tooltip
                  title={
                    <Typography>
                      {this.props.t("global_ranked") +
                        " " +
                        this.props.data.likedRanking +
                        " " +
                        this.props.t("global_most_liked")}
                    </Typography>
                  }
                >
                  <Badge>
                    <span
                      style={{ fontSize: "1.4em", marginRight: "3px" }}
                      className="mdi mdi-trophy-outline"
                    />
                    {this.props.data.likedRanking}
                  </Badge>
                </Tooltip>
              </span>
            )}
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={fontWeight}>
                {this.props.t("settings_document_number_of_liked")}
              </div>
              <div>{this.props.data.likedCount}&nbsp;</div>
            </div>
          </>
        )}
        {setting === "settings_document_number_of_times_favourited" && (
          <>
            {this.props.data.favouriteRanking > 0 && (
              <span style={{ marginLeft: "10px" }}>
                <Tooltip
                  title={
                    <Typography>
                      {this.props.t("global_ranked") +
                        " " +
                        this.props.data.favouriteRanking +
                        " " +
                        this.props.t("global_most_favourited")}
                    </Typography>
                  }
                >
                  <Badge>
                    <span
                      style={{ fontSize: "1.4em", marginRight: "3px" }}
                      className="mdi mdi-trophy-outline"
                    />
                    {this.props.data.favouriteRanking}
                  </Badge>
                </Tooltip>
              </span>
            )}
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={fontWeight}>
                {this.props.t("settings_document_number_of_times_favourited")}
              </div>
              <div>{this.props.data.favouritedCount}&nbsp;</div>
            </div>
          </>
        )}
        {setting === "settings_document_number_of_times_viewed" && (
          <>
            {this.props.data.viewedRanking > 0 && (
              <span style={{ marginRight: "3px" }}>
                <Tooltip
                  title={
                    <Typography>
                      {this.props.t("global_ranked") +
                        " " +
                        this.props.data.viewedRanking +
                        " " +
                        this.props.t("global_most_viewed")}
                    </Typography>
                  }
                >
                  <Badge>
                    <span
                      style={{ fontSize: "1.4em", marginRight: "3px" }}
                      className="mdi mdi-trophy-outline"
                    />
                    {this.props.data.viewedRanking}
                  </Badge>
                </Tooltip>
              </span>
            )}
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={fontWeight}>
                {this.props.t("settings_document_number_of_times_viewed")}
              </div>
              <div>{this.props.data.viewedCount}&nbsp;</div>
            </div>
          </>
        )}
        {setting === "settings_document_number_of_times_used" && (
          <>
            {this.props.data.usageRanking > 0 && (
              <span style={{ marginRight: "3px" }}>
                <Tooltip
                  title={
                    <Typography>
                      {this.props.t("global_ranked") +
                        " " +
                        this.props.data.usageRanking +
                        " " +
                        this.props.t("global_most_used")}
                    </Typography>
                  }
                >
                  <Badge>
                    <span
                      style={{ fontSize: "1.4em", marginRight: "3px" }}
                      className="mdi mdi-trophy-outline"
                    />
                    {this.props.data.usageRanking}
                  </Badge>
                </Tooltip>
              </span>
            )}
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={fontWeight}>
                {this.props.t("settings_document_number_of_times_used")}
              </div>
              <div>{this.props.data.usedCount}&nbsp;</div>
            </div>
          </>
        )}
        {setting === "settings_document_date_last_viewed_by_me" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_document_date_last_viewed_by_me")}
            </div>
            <div>
              :{" "}
              {!!this.props.data.myLastViewed
                ? this.props.data.myLastViewed.format("lll")
                : "n/a"}&nbsp;
            </div>
          </div>
        )}
        {setting === "settings_document_user_who_last_modified" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_document_user_who_last_modified")}
              :{" "}
            </div>
            <div>
              <DisplayUser
                noAvatar
                userId={this.props.data.lastModifiedByUser.userId}
                user={this.props.data.lastModifiedByUser}
              />
            </div>
          </div>
        )}
        {this.props.currentUser.userPermits.roles.beExpert &&
          setting === "settings_document_rework_count" && (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={fontWeight}>
                {this.props.t("settings_document_rework_count")}
              </div>
              <div>{this.props.data.reworkCount}&nbsp;</div>
            </div>
          )}
        {setting === "settings_document_author" && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <div style={fontWeight}>
              {this.props.t("settings_document_author")}
              :{" "}
            </div>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <DisplayUser
                noAvatar
                userId={
                  this.props.data.author ? this.props.data.author.userId : ""
                }
                user={this.props.data.author}
              />{" "}
            </div>
          </div>
        )}
        {setting === "settings_document_live_revision_author" && (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div style={fontWeight}>
              {this.props.t("settings_document_live_revision_author")}
              :{" "}
            </div>
            <div>
              <DisplayUser
                noAvatar
                userId={
                  this.props.data.liveRevisionAuthor
                    ? this.props.data.liveRevisionAuthor.userId
                    : ""
                }
                user={this.props.data.liveRevisionAuthor}
              />{" "}
            </div>
          </div>
        )}
      </span>
    );
  };
  checkForIcons = () => {
    let hasIcons = false
    if (this.props.data.newlyAdded) {
      hasIcons = true
    }
    if (this.props.data.showHasChanged) {
      hasIcons = true
    }
    if (this.props.data.favourite) {
      hasIcons = true
    }
    if (this.props.data.myLiked) {
      hasIcons = true
    }
    if (this.props.data.workflowState && (
        this.props.data.workflowState === "AWAITING_APPROVAL" ||
        this.props.data.workflowState === "AWAITING_REVIEW" ||
        this.props.data.workflowState === "AWAITING_PUBLISH")) {
      hasIcons = true
    }
    if (this.props.data.hasDraft) {
      hasIcons = true
    }
    if (this.props.currentUser.userPermits.roles.beExpert &&
      this.props.data.reworkCount > 0 &&
      this.props.data.canMarkForRework) {
        hasIcons = true
    }
    return hasIcons

  }
  secondaryInfo(settings) {
    if (!this.props.fullscreen) {
      if (this.props.secondaryInfo) {
        return this.props.secondaryInfo;
      }
      if (!settings) {
        settings = "settings_document_author";
      }
      const hasIcons = this.checkForIcons()
      const { classes } = this.props;
      let info = (
        <div style={{ display: "flex" }}>
          {hasIcons === true && (
          <span className={classes.iconSpan}>
            {this.props.data.newlyAdded && (
              <Tooltip
                title={<Typography>{this.props.t("newly_added")}</Typography>}
                aria-label={this.props.t("newly_added")}
              >
                <AddAlertIcon color="secondary" />
              </Tooltip>
            )}
            {this.props.data.showHasChanged && (
              <Tooltip
                title={
                  <Typography>{this.props.t("document_updated")}</Typography>
                }
                aria-label={this.props.t("document_updated")}
              >
                <AnnouncementIcon
                  onClick={this.onUpdatedClick}
                  color="secondary"
                />
              </Tooltip>
            )}
            {this.props.data.favourite && (
              <Tooltip
                title={
                  <Typography>
                    {this.props.t("global_favourite_past_tense")}
                  </Typography>
                }
                aria-label={this.props.t("global_favourite_past_tense")}
              >
                <StarIcon color="primary" />
              </Tooltip>
            )}
            {this.props.data.myLiked && (
              <Tooltip
                title={
                  <Typography>
                    {this.props.t("global_like_past_tense")}
                  </Typography>
                }
                aria-label={this.props.t("global_like_past_tense")}
              >
                <ThumbUpIcon color="primary" />
              </Tooltip>
            )}
            {this.props.data.workflowState && (
              <>
                {this.props.data.workflowState === "AWAITING_APPROVAL" && (
                  <Tooltip
                    title={
                      <Typography>
                        {this.props.t("document_awaiting_approval")}
                      </Typography>
                    }
                    aria-label={this.props.t("document_awaiting_approval")}
                  >
                    <AssignmentLateIcon color="primary" />
                  </Tooltip>
                )}
                {this.props.data.workflowState === "AWAITING_REVIEW" && (
                  <Tooltip
                    title={
                      <Typography>
                        {this.props.t("document_awaiting_review")}
                      </Typography>
                    }
                    aria-label={this.props.t("document_awaiting_review")}
                  >
                    <AssignmentLateIcon color="primary" />
                  </Tooltip>
                )}
                {this.props.data.workflowState === "AWAITING_PUBLISH" && (
                  <Tooltip
                    title={
                      <Typography>
                        {this.props.t("document_awaiting_publish")}
                      </Typography>
                    }
                    aria-label={this.props.t("document_awaiting_publish")}
                  >
                    <AssignmentLateIcon color="primary" />
                  </Tooltip>
                )}
              </>
            )}
            {this.props.data.hasDraft && (
              <Tooltip
                title={
                  <Typography>
                    {this.props.t("document_has_draft_version")}
                  </Typography>
                }
                aria-label={this.props.t("document_has_draft_version")}
              >
                <CreateIcon color="primary" />
              </Tooltip>
            )}
            {this.props.currentUser.userPermits.roles.beExpert &&
              this.props.data.reworkCount > 0 &&
              this.props.data.canMarkForRework && (
                <Tooltip
                  title={
                    <Typography>
                      {this.props.t("document_has_rework")}
                    </Typography>
                  }
                  aria-label={this.props.t("document_has_rework")}
                >
                  <FlagIcon color="secondary" />
                </Tooltip>
              )}
          </span>
          )}
          {this.returnSettingsItem(settings)}
        </div>
      );
      this.setState({ secondaryString: info });
    } else {
      this.setState({ secondaryString: "" });
    }
  }
}

const mapStateToProps = (state) => ({
  documentOptions: state.selectionOption.documentSettingsOptions,
  itemMappings: state.itemMappings.DocumentItem,
  currentUser: state.user.currentUser,
  portalLayout: state.layout.currentLayout,
  properties: state.setting.applicationProperties,
  teamLayoutEditMode: state.layout.teamLayoutEditMode,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  {
    forwardRef: true,
  }
)(withStyles(styles)(withRouter(withTheme(withTranslation()(DocumentItem)))));
